import { ActorType } from '../../../app/data/interaction/actor-type';
import { EncounterActionType } from '../../../app/data/interaction/action-type';
import { encounterEvent } from '../travel/travel.actions';

export const makeActionEvent = (actor: ActorType) => (
  action: EncounterActionType,
) => encounterEvent({ actor, action });
